'use client';

import { useQuery, useMutation } from '@tanstack/react-query';

import { COMPANY_ID, JWT_STORAGE_KEY, USER_ID_STORAGE_KEY } from 'src/utils/constants';

import { restClient, paymentClient } from 'src/lib/api';

export const useGetWalletBalance = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const userID = sessionStorage.getItem(USER_ID_STORAGE_KEY);
  const mutationFn = (payload) =>
    paymentClient
      .post('api/v1/payments/payment/balanceInWallet', null, {
        headers: {
          token,
        },
        params: {
          token,
          userID,
        },
      })
      .then((res) => res.data?.success);
  return useMutation({
    mutationFn,
    mutationKey: ['walletBalance'],
  });
};

/**
 * Pay Extra Charges using Wallet Only
 * @returns
 */
export const usePayExtraChargesUsingWallet = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const mutationFn = (payload) =>
    paymentClient
      .post('api/v1/payments/payment/EC/extraChargeUsingWallet', payload, {
        headers: {
          token,
        },
      })
      .then((res) => res.data);
  return useMutation({
    mutationFn,
    mutationKey: ['payment_PayExtraChargesUsingWallet'],
  });
};

export const useGetCompanyCreditDetails = () => {
  const userID = sessionStorage.getItem(USER_ID_STORAGE_KEY);
  const companyID = localStorage.getItem(COMPANY_ID);
  const query = useQuery({
    queryKey: ['payment_getCompanyCreditDetails'],
    queryFn: () =>
      restClient
        .get('getCompanyCreditDetails', {
          params: {
            userID: companyID || userID,
            token: localStorage.getItem(JWT_STORAGE_KEY),
          },
        })
        .then((res) => res?.data),
    enabled: !!userID, // prevent auto-run if userId or driverID is undefined
  });

  return query;
};

/**
 * Pay PAD  using Wallet Only
 * @returns
 */
export const usePADUsingWallet = () => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const mutationFn = (payload) =>
    paymentClient
      .post('api/v1/payments/payment/PAD/usingWallet', payload, {
        headers: {
          token,
        },
      })
      .then((res) => res.data);
  return useMutation({
    mutationFn,
    mutationKey: ['payment_PayExtraChargesUsingWallet'],
  });
};
